import { all, call, fork, put, takeEvery } from 'redux-saga/effects'

import { toast } from '../../notifications'
import { api } from '../../services'

import {
  closeAuth,
  login,
  loginFailure,
  loginSuccess,
  logout,
  logoutFailure,
  logoutSuccess,
  register,
  registerFailure,
  registerSuccess,
  reset,
  resetFailure,
  resetSuccess
} from './actions'

const GENERIC_ERROR_MESSAGE = 'Es ist ein unbekannter Fehler aufgetreten.'

function * callApi (apiCall, params, { success: successAction, failure: failureAction }) {
  try {
    const response = yield call(apiCall, params)
    // Do not use ...restParam with generators as it causes double request issue
    const { data: { success, errors, message, ...data } } = response

    if (success) {
      yield put(successAction(data))
      return { success, message }
    } else {
      if (!message && (!errors || errors.length === 0)) {
        yield put(failureAction({ message: GENERIC_ERROR_MESSAGE }))
      } else {
        yield put(failureAction({ message, errors }))
      }
      return { success, message }
    }
  } catch (e) {
    yield put(failureAction((e.response ? e.response.data : null) || { message: GENERIC_ERROR_MESSAGE }))
  }
  return { success: false }
}

function * performLogin ({ payload }) {
  const { success, message = 'Sie wurden erfolgreich angemeldet.' } = yield callApi(api.auth.login, payload, {
    success: loginSuccess,
    failure: loginFailure
  })
  if (success) {
    yield put(closeAuth())
    toast.success(message)
  }
}

function * performLogout ({ payload }) {
  const { success, message } = yield callApi(api.auth.logout, payload, {
    success: logoutSuccess,
    failure: logoutFailure
  })
  if (message) {
    toast[success ? 'success' : 'error'](message)
  }
}

function * performRegister ({ payload }) {
  yield callApi(api.auth.register, payload, {
    success: registerSuccess,
    failure: registerFailure
  })
}

function * performReset ({ payload }) {
  const {
    success,
    message = 'Wir haben Ihnen eine E-Mail mit der Anleitung zur Passwortänderung zugeschickt.'
  } = yield callApi(api.auth.reset, payload, {
    success: resetSuccess,
    failure: resetFailure
  })
  if (success) {
    yield put(closeAuth())
    toast.success(message)
  }
}

export function * watchAjax () {
  yield all([
    takeEvery(login, performLogin),
    takeEvery(logout, performLogout),
    takeEvery(register, performRegister),
    takeEvery(reset, performReset)
  ])
}

export default fork(watchAjax)
